__turbopack_context__.v({
  "bg-secondary-base": "A19DCa_bg-secondary-base",
  "search-subtitle": "A19DCa_search-subtitle",
  "searchImageText": "A19DCa_searchImageText",
});
